import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dynamic-category-icon',
  templateUrl: './dynamic-category-icon.component.html',
  styleUrls: ['./dynamic-category-icon.component.scss'],
})
export class DynamicCategoryIconComponent  implements OnInit {
  @Input() size :number = 20;
  @Input() name :string = "Category"; 

  categoriesWithIcon = [];

  constructor() { }

  ngOnInit() { }
}
